import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
import TimerOutlinedIcon from "@material-ui/icons/TimerOutlined";
import { OrderDetails_order_subOrders } from "@saleor/motherOrders/types/OrderDetails";
import * as React from "react";

interface PrepTimeLocationProps {
  order: OrderDetails_order_subOrders;
}

const useStyles = makeStyles(
  theme => ({
    icon: {
      color: "rgb(155, 81, 224)",
      marginRight: "2px"
    },
    item: {
      display: "flex",
      marginBottom: "3px",
      marginTop: "3px"
    },
    locationPrepTime: {
      [theme.breakpoints.down("lg")]: {
        display: "flex",
        flexDirection: "column"
      }
    }
  }),
  {
    name: "PrepTimeLocation"
  }
);

const PrepTimeLocation: React.FC<PrepTimeLocationProps> = props => {
  const { order } = props;
  const classes = useStyles(props);

  return (
    // <div className={classes.locationPrepTime}>
    //   <div>
    //     <LocationOnOutlinedIcon />{" "}
    //     <span>Sm Mall of Asia, J.W Diokno Blvd, Pasay, 1300 Metro Manila</span>
    //   </div>

    //   <div style={{ display: "flex" }}>
    //     <TimerOutlinedIcon /> <span>Ave. PrepTime : 15 mins</span>
    //   </div>
    // </div>
    <Grid container>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
        <div className={classes.item}>
          <LocationOnOutlinedIcon className={classes.icon} />{" "}
          <span>
            {order?.tenant?.location ? order?.tenant?.location : "--"}
          </span>
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
        <div className={classes.item}>
          <TimerOutlinedIcon className={classes.icon} />{" "}
          <span>
            Ave. PrepTime :{" "}
            {order?.prepTimeLower ? <b> {order?.prepTimeLower} mins</b> : "--"}{" "}
            -{" "}
            {order?.prepTimeUpper ? <b> {order?.prepTimeUpper} mins</b> : "--"}
          </span>
        </div>
      </Grid>
    </Grid>
  );
};

export default PrepTimeLocation;
